import {BaseSearchRequest} from "./baseSearchRequest";
import {TariffSource} from "../tariffs/tariffSource";
import {RequestType} from "../products/requestType";
/**
 * Created by alex.y on 9/11/2017.
 */

export class ProductSearchRequest extends BaseSearchRequest{
    public Source?: TariffSource;
    public RequestType: RequestType;
    public SearchType: number = 1;
    public CustomerId: number | string;

    public constructor(obj : Partial<ProductSearchRequest>){
        super();
        Object.assign(this,obj);
    }
}


// WEBPACK FOOTER //
// ./app/objects/requests/productSearchRequest.ts